import React, { useEffect, useState, useContext } from "react";
import API from "../api";
import { LangContext } from "../App";
import MultiSelect from "react-multi-select-component";

export default function SelectCategory(props) {
  const { onMultiple, selected } = props;
  const [cats, setCats] = useState([]);
  const lang = useContext(LangContext);

  const translate = {
    selectSomeItems: "Označiť...",
    allItemsAreSelected: "Označené sú všetky položky.",
    selectAll: "Označiť všetko",
    search: "Hľadať",
    clearSearch: "Zmazať hľadanie",
  };

  function getCats(lang) {
    API.get(`${lang === "en" ? "en/" : ""}wp-json/wp/v2/categories`).then(
      (res) => {
        const options = res.data.map((option) => {
          return { label: option.name, value: option.slug };
        });

        setCats(options);
      }
    );
  }

  useEffect(() => {
    getCats(lang);
  }, [lang]);

  function onMultipleHandler(data) {
    onMultiple(data);
  }

  return (
    <>
      <label
        id="search-label"
        className="search-label"
        htmlFor="search-category"
      >
        {lang === "sk" ? "Oblasť záujmu" : "Field of interest"}
      </label>
      <MultiSelect
        options={cats}
        value={selected}
        onChange={onMultipleHandler}
        labelledBy={"search-label"}
        overrideStrings={lang === "sk" ? translate : {}}
      />
    </>
  );
}
